export default __webpack_public_path__ + "static/media/ic_uni_24.8f367e8c.svg";